import { useContext, useMemo } from "react";
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { AuthContext } from "../contexts/AuthContext";

export function useFirebaseConnection() {
  const { userFirebase } = useContext(AuthContext);

  const userApp = useMemo(() => {
    if (!userFirebase?.projectId) return null;

    const config = {
      apiKey: userFirebase.apiKey,
      authDomain: userFirebase.authDomain,
      projectId: userFirebase.projectId,
      storageBucket: userFirebase.storageBucket,
      messagingSenderId: userFirebase.messagingSenderId,
      appId: userFirebase.appId,
    };

    return getApps().find(app => app.name === config.projectId)
      || initializeApp(config, config.projectId);
  }, [userFirebase]);

  const auth = userApp ? getAuth(userApp) : null;
  const db = userApp ? getFirestore(userApp) : null;

  return { auth, db };
}
